// POST /v1/billing/portal-session — Stripe Customer Portal redirect.
// The Portal lets the user manage their card, change subscription,
// view invoices, or cancel — without us reimplementing any of it.
const action = "BILLING_PORTAL";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

export const openPortal     = ()          => ({ type: REQUEST });
export const portalSuccess  = (response) => ({ type: RESPONSE, payload: response });
export const portalFailure  = (error)    => ({ type: FAILURE,  payload: error });
export const clearState     = ()          => ({ type: CLEAR });
